<template>
  <div class="header">
    <div class="left">
      <div class="logo">
        <img
          src="@/assets/image/login/logo.png"
          alt="logo"
        >
      </div>
      <div class="area">
        <p class="text">{{$t('银行当地时间')}}：{{$t(serviceIitem)}}</p>
        <ToggleLang />
        <div
          class="switch-btn"
          @click="handleSwitch"
        >{{$t('版本切换')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/views/home/api'
// import { corporbankUrl } from '@/config/constants'
import { changeVersionByDomain } from '@/utils/domain'
export default {
  data () {
    return {
      weekArr: {
        1: '周日',
        2: '周一',
        3: '周二',
        4: '周三',
        5: '周四',
        6: '周五',
        7: '周六'
      },
      year: '',
      month: '',
      day: '',
      hour: '',
      minute: '',
      week: ''
    }
  },
  computed: {
    serviceIitem () {
      const { year, month, day, hour, minute, week } = this
      const lang = this.$store.state.app.lang
      const zh = `${year}${this.$t('年')}${month}${this.$t('月')}${day}${this.$t('日')}   (${this.$t(this.weekArr[week])})   ${hour}:${minute}`
      const en = `${year}-${month}-${day}   (${this.$t(this.weekArr[week])})   ${hour}:${minute}`
      return lang === 'en' ? en : zh
    }

  },
  methods: {
    getServerDateTime () {
      api.getServerDateTime().then(res => {
        if (res) {
          const { dateTime, week } = res
          const year = dateTime.substring(0, 4)
          const month = dateTime.substring(4, 6)
          const day = dateTime.substring(6, 8)
          const hour = dateTime.substring(8, 10)
          const minute = dateTime.substring(10, 12)
          // const seconds = dateTime.substring(12, 14)
          this.year = year
          this.month = month
          this.day = day
          this.hour = hour
          this.minute = minute
          this.week = week
        }
      }).catch(err => {
        console.error(err)
      })
    },
    handleSwitch () {
      changeVersionByDomain()
    }
  },
  mounted () {
    this.getServerDateTime()
  }
}
</script>
<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
  height: 64px;
  background: #060432;
  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1 1 0%;
    padding: 0 60px;
    .logo {
      width: 136px;
      height: 36px;
      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .area {
      display: flex;
      align-items: center;
      height: 100%;
      .text {
        margin-right: 50px;
        .tip-text();
      }
      .switch-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 90px;
        height: 32px;
        padding: 0 18px;
        font-size: 14px;
        font-weight: 300;
        color: @white;
        line-height: 14px;
        background: @blueLess80;
        border-radius: 4px;
        cursor: pointer;
        &:hover {
          background: @blue;
        }
      }
    }
  }
}
</style>
